import { refreshAudioMix } from '../../../../shared/store/use-cases/refresh-audio-mix.ts'
import useTracksStore from '../../../../shared/store/tracks.store.tsx'
import useMediaStore from '../../../../shared/store/media.store.tsx'
import { useHistoryStore } from '../../../../shared/store/history.store.tsx'
import type { Clip } from '../models/clip.ts'

export const addClip = (clip: Clip): void => {
  const { addClip } = useTracksStore.getState()
  const media = useMediaStore.getState().media

  addClip(clip.trackId, clip)
  useTracksStore.getState().setGeneratedMix(undefined)

  // Save snapshot to mark state as dirty when clip is added
  // This ensures all clips (media files, sound designs, etc.) trigger auto-save
  useHistoryStore.getState().saveSnapshot()

  // Also mark as dirty if clip is missing src (still being generated/fetched)
  // This prevents user from leaving while sound design or other async clips are loading
  if (!clip.src) {
    useHistoryStore.setState({ saveStatus: 'dirty' })
  }

  const audioBuffer = media[clip.mediaId]
  if (audioBuffer) {
    void refreshAudioMix()
    return
  }

  const unsub = useMediaStore.subscribe(
    (state) => state.media[clip.mediaId],
    (newBuffer) => {
      if (!newBuffer) return
      unsub()
      void refreshAudioMix()
    }
  )
}
